import { useEffect, useState } from "react";
import { Search, HelpCircle } from "lucide-react";
import UniversalSearch from "@/components/search/UniversalSearch";
import HelpGuide from "@/components/help/HelpGuide";

// tone: "dark" (glass over dark gateway) | "light" (over linen Toolbox)
const SanctuaryHeader = ({ tone = "dark", className = "" }) => {
  const [searchOpen, setSearchOpen] = useState(false);
  const [helpOpen, setHelpOpen] = useState(false);

  useEffect(() => {
    const onKey = (e) => {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === "k") {
        e.preventDefault();
        setSearchOpen((v) => !v);
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  const btn =
    tone === "dark"
      ? "text-white/60 hover:text-white bg-white/5 hover:bg-white/10 border border-white/10 backdrop-blur-md"
      : "text-ink-2 hover:text-brand bg-white hover:bg-linen-2 border border-linen-3";

  return (
    <>
      <div className={`flex items-center gap-2 ${className}`} data-testid="sanctuary-header">
        <button
          onClick={() => setSearchOpen(true)}
          className={`flex items-center gap-2 rounded-full h-10 px-4 text-sm transition-all ${btn}`}
          data-testid="open-search"
          aria-label="Open search"
        >
          <Search className="w-4 h-4" />
          <span className="hidden sm:inline">Search</span>
        </button>
        <button
          onClick={() => setHelpOpen(true)}
          className={`flex items-center justify-center rounded-full w-10 h-10 transition-all ${btn}`}
          data-testid="open-help"
          aria-label="Open help guide"
        >
          <HelpCircle className="w-[18px] h-[18px]" />
        </button>
      </div>

      <UniversalSearch open={searchOpen} onClose={() => setSearchOpen(false)} />
      <HelpGuide open={helpOpen} onClose={() => setHelpOpen(false)} />
    </>
  );
};

export default SanctuaryHeader;
